export enum OriginClient {
  Generic = 'Generic',
  TradingView = 'TradingView',
}
